import { render, staticRenderFns } from "./TableListVatPending.vue?vue&type=template&id=9f93b586&"
import script from "./TableListVatPending.vue?vue&type=script&lang=js&"
export * from "./TableListVatPending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports